import axios from "axios";
import qs from "qs";

function like(id, type) {
  // 评论 喜欢 不喜欢
  // like 1 dislike -1
  if (!type) {
    type = 1;
  }
  if (id < 1) {
    return null;
  }
  const url = "/wp/wp-admin/admin-ajax.php?nocache=1";
  const data = {
    comment_ID: id,
    vote_type: type,
    action: "wc_vote_via_ajax",
  };
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(data), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
function submitComment(url, data) {
  // 提交评论
  // let url = "/wp"+this.$refs.leaveCommentForm.getAttribute('action');
  // let data = {
  //   author:this.$refs.nameInput.value,
  //   email: this.$refs.emailInput.value,
  //   comment: this.$refs.commentInput.value,
  //   comment_post_ID: this.commentPostID,
  //   comment_parent: this.commentParent,
  //   url: location.host
  // }
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(data), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

export default {
  like: like,
  submitComment: submitComment,
};
